import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Card,
  CardMedia,
  CardActionArea,
  CircularProgress
} from '@mui/material';
import { fetchUtils } from 'react-admin';

const REACT_APP_URL_API = process.env.REACT_APP_URL_API;
// const REACT_APP_SERVER_API = process.env.REACT_APP_SERVER_API;
// const REACT_APP_PORT_API = process.env.REACT_APP_PORT_API || 3001;
// const REACT_APP_PATH_API = process.env.REACT_APP_PATH_API;
// const REACT_APP_PATH_API_IMAGE = process.env.REACT_APP_PATH_API_IMAGE;

// const BASE_IMAGE_URL = `${REACT_APP_SERVER_API}:${REACT_APP_PORT_API}/${REACT_APP_PATH_API}/${REACT_APP_PATH_API_IMAGE}`;

const ImageSelectorModal = ({ open, onClose, onSelect }) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (open) {
      fetchUtils.fetchJson(`${REACT_APP_URL_API}/image/cloudinary`)
        .then(({ json }) => {
          setImages(json);
          setLoading(false);
        })
        .catch(err => {
          console.error('Error fetching images:', err);
          setLoading(false);
        });
    }
  }, [open]);

  const handleSelect = (url) => {
    onSelect(url);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Seleccionar Imagen</DialogTitle>
      <DialogContent>
        {loading ? (
          <CircularProgress />
        ) : (
          <Grid container spacing={2}>
            {images.map((image) => (
              <Grid item xs={4} key={image.id}>
                <Card>
                  <CardActionArea onClick={() => handleSelect(image.url)}>
                    <CardMedia
                      component="img"
                      height="140"
                      image={image.url}
                      alt={image.name}
                    />
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ImageSelectorModal;
